<template>
  <q-dialog :value="show" persistent maximized content-class="position-dialog">
    <q-card class="dialog-content">
      <q-card-section class="card-header">
        <q-btn
          unelevated
          class="primary border-radius-8 backBtn"
          icon="app:backBIcon"
          @click="$emit('close')"
        />
        <span class="title q-ml-md">
          {{ $t('googlemap.newAddrSet') }}
        </span>
      </q-card-section>
      <q-card-section class="q-pt-none">
        <Map ref="customMap" :center="point" @getInfo="getAdressInfo" />
      </q-card-section>
      <q-card-section class="q-py-none">
        <div class="addressBox">
          <q-icon
            size="20px"
            class="beforeIcon vertical-middle q-mr-xs"
            name="font:dm-location"
          />
          <span>
            {{ addressInfo.address }}
          </span>
        </div>
      </q-card-section>
      <!-- <q-card-section class="q-pb-none">
        <div class="address-address">
          <div class="option bg-white q-py-sm maxlength">
            <span class="label">
              {{ $t('googlemap.addressDetail') }}
            </span>
            <q-input
              v-model="custom.detail"
              class="inputBox"
              placeholder="Eg: NO.22,Floor 3"
              outlined
              counter
              maxlength="100"
            />
          </div>
          <div class="option bg-white q-py-sm maxlength">
            <span class="label"> {{ $t('googlemap.addressTag') }} </span>
            <q-input
              v-model="custom.label"
              class="inputBox"
              placeholder="Eg: home"
              outlined
              counter
              maxlength="50"
            />
          </div>
        </div>
      </q-card-section> -->
      <q-card-section>
        <!-- <div class="savaAddress">
          <q-checkbox
            v-model="custom.save"
            :label="$t('googlemap.saveAddress')"
          />
        </div> -->
        <q-btn
          no-caps
          unelevated
          color="primary"
          class="full-width border-radius-8 text-weight-bolder font-size-16"
          :label="$t('googlemap.useThisAddr')"
          :loading="loading"
          @click="onSave"
        />
      </q-card-section>
    </q-card>
  </q-dialog>
</template>

<script>
import { mapState } from 'vuex';
import { saveGMAddress } from 'src/api/googlemap';
import Map from './Map.vue';
import { getSaveParam } from '../../../../components/utils';

export default {
  components: { Map },
  model: {
    prop: 'show',
    event: 'close',
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    point: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      addressInfo: {
        address: '',
        position: {
          lng: '',
          lat: '',
        },
      },

      custom: {
        detail: '',
        label: '',
        save: false,
      },
      loading: false,
    };
  },
  ...mapState({
    localAddress: (state) => state.Menu.addressInfo,
  }),
  watch: {
    show(val) {
      if (val) {
        this.$nextTick(() => {
          this.$refs.customMap.initMap();
        });
      }
    },
  },
  mounted() {},
  methods: {
    onSave() {
      // const params = {
      //   districtName: 'Kecamatan Kebayoran Baru',
      //   subDistrictName: 'Kecamatan Kebayoran Baru',
      //   cityName: 'Kota Jakarta Selatan',
      //   stateProvinceName: 'Daerah Khusus Ibukota Jakarta',
      //   countryName: 'Indonesia',
      //   postalCode: '12150',
      //   address3:
      //     `Jl. Kirai I No.36b, RT.10/RW.1,
      //     Cipete Utara, Kec. Kby. Baru,
      //     Kota Jakarta Selatan, Daerah
      //     Khusus Ibukota Jakarta 12150, Indonesia`,
      //   toName: 'test501',
      //   phone: '+62812345501',
      //   latitude: -6.2578327,
      //   longitude: 106.8004983,
      //   asDefault: true,
      //   address1: '',
      //   address2: '',
      //   email: 'noah.huang@desty.app',
      // };
      // saveGMAddress({ address: params }).then(res => {
      //   // console.log(res);
      // });
      this.loading = true;
      this.$emit('setPlace', this.addressInfo);
      this.$emit('close');
      this.loading = false;

      // save to delivery address
      const geoData = this.$refs.customMap.nativeGeocodeData;
      const saveParams = getSaveParam.call(this, geoData);
      const address = {
        ...saveParams,
        asDefault: true,
        address1: '',
        address2: '',
      };
      this.$store.dispatch('Menu/setAddressInfo', address);
    },
    getAdressInfo(val) {
      this.addressInfo = val;
    },
  },
};
</script>

<style lang="scss">
.pac-container {
  z-index: 7000;
  width: calc(90% - 24px) !important;
  left: calc(5% + 12px) !important;
}
.position-dialog {
  .dialog-content {
    .card-header {
      display: flex;
      align-items: center;
      height: 64px;
      .q-btn {
        width: 40px;
        height: 40px;
        .q-btn__wrapper {
          padding: 0;
        }
      }
      .title {
        font-size: 20px;
        line-height: 22px;
        color: $black;
        font-weight: 800;
      }
    }
  }
  .addressBox {
    display: flex;
    align-items: center;
    color: $black;
    span {
      font-weight: bold;
    }
  }
  .address-address {
    .q-field--outlined .q-field__control:before {
      border-color: #d1d5db;
      box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.05);
      border-radius: 8px;
    }
    .q-field__control {
      height: 42px;
      min-height: unset;
    }
    .inputBox {
      height: 42px;
      padding-bottom: 0;
      margin-top: 8px;
    }
    .q-field__bottom--animated {
      bottom: 72px !important;
      color: #6b7280;
      font-size: 12px;
    }
    .q-field__counter {
      font-size: 12px;
    }
    .label {
      font-weight: bold;
      color: $black;
      font-size: 12px;
      line-height: 120%;
      margin-bottom: 6px;
    }
  }
  .savaAddress {
    margin-left: -10px;
  }
}
</style>
